(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-drawer')) {
    class CartDrawer extends HTMLElement {
      connectedCallback() {
        this.panel = this.querySelector('.cart-drawer__panel');
        this.body = this.querySelector('[data-cart-body]');
        this.footer = this.querySelector('[data-cart-footer]');
        this.subtotal = this.querySelector('[data-cart-subtotal]');
        this.moneyFormat = this.dataset.moneyFormat;
        this.labels = {
          decrease: this.dataset.labelDecrease,
          increase: this.dataset.labelIncrease,
          remove: this.dataset.labelRemove,
          empty: this.dataset.labelEmpty,
        };

        this.querySelectorAll('[data-cart-close]').forEach((button) => {
          button.addEventListener('click', () => this.close());
        });

        this.addEventListener('click', (event) => {
          if (event.target.closest('[data-cart-close]')) {
            this.close();
            return;
          }
          const extraAdd = event.target.closest('[data-cart-extra-add]');
          if (extraAdd) {
            this.addVariant(Number(extraAdd.dataset.variantId), extraAdd);
            return;
          }
          const remove = event.target.closest('[data-cart-remove]');
          if (remove?.dataset.lineKey) {
            this.change(remove.dataset.lineKey, 0);
            return;
          }
          const qty = event.target.closest('[data-cart-qty]');
          if (!qty) return;
          const line = qty.closest('[data-line-key]');
          if (!line) return;
          this.change(line.dataset.lineKey, Number(qty.dataset.cartQty));
        });

        document.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-cart-open]');
          if (!trigger) return;
          event.preventDefault();
          this.open();
        });

        document.addEventListener('submit', (event) => {
          const form = event.target;
          if (!(form instanceof HTMLFormElement) || !form.action.includes('/cart/add')) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.add(form);
        }, true);

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.classList.contains('is-open')) this.close();
        });

        this.readCatalog();
        this.paintShipDates();
        this.prefetch();
        const guard = this.querySelector('[data-cart-guard]');
        if (guard) {
          guard.addEventListener('change', () => this.toggleGuard(guard));
        }
        const checkout = this.querySelector('.cart-drawer__checkout');
        this.defaultCheckout = checkout?.getAttribute('href') || '';
        checkout?.addEventListener('click', async (event) => {
          if (!this.dealCheckoutUrl()) return;
          event.preventDefault();
          event.stopPropagation();
          let items = this.cart?.items;
          try {
            await this.changeQueue;
            const root = window.Shopify?.routes?.root || '/';
            const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
            if (response.ok) {
              this.cart = await response.json();
              items = this.cart.items;
            }
          } catch (error) {}
          window.location.assign(this.dealCheckoutUrl(items) || this.defaultCheckout || checkout.href);
        });
        try {
          if ((sessionStorage.getItem('innerday-deals') || '').includes('once')) this.refresh();
        } catch (error) {}
        window.addEventListener('pageshow', (event) => {
          if (event.persisted) this.refresh();
        });
      }

      dealLines() {
        try {
          return JSON.parse(sessionStorage.getItem('innerday-deal-lines') || '{}');
        } catch (error) {
          return {};
        }
      }

      dealCheckoutUrl(items) {
        const deal = this.dealLines();
        const lines = items || this.cart?.items || [];
        const gifts = { 5: [8], 6: [16, 19], 12: [19], 13: [8, 19] };
        const extraCard = this.querySelector('[data-cart-extra]');
        const extraId = Number(extraCard?.dataset.variantId || 0);
        const extraPackage = extraCard?.dataset.extraPackage || '7';
        const organizerCard = this.querySelector('[data-cart-organizer]');
        const organizerId = Number(organizerCard?.dataset.variantId || 0);
        const organizerPackage = organizerCard?.dataset.package || '20';
        const guardId = this.guardId();
        const packs = [];
        const free = [];
        let extraQty = 0;
        let organizerQty = 0;
        let guard = false;
        lines.forEach((item) => {
          if (item.parent_relationship || this.isGift(item)) return;
          const id = Number(item.variant_id);
          const qty = item.quantity || 1;
          const pack = deal[id];
          if (organizerId && id === organizerId) {
            organizerQty += qty;
          } else if (extraId && id === extraId) {
            extraQty += qty;
          } else if (pack) {
            packs.push(`${pack}:${qty}`);
            (gifts[pack] || []).forEach((gift) => free.push(`${gift}:${qty}`));
          } else if (guardId && id === guardId) {
            guard = true;
          }
        });
        if (!packs.length) return '';
        const parts = [...packs];
        const cleanseBundle = packs.some((part) => part.startsWith('13:'));
        if (extraQty && !(cleanseBundle && extraPackage === '18')) parts.push(`${extraPackage}:${extraQty}`);
        parts.push(...free);
        if (organizerQty) parts.push(`${organizerPackage}:${organizerQty}`);
        if (guard) parts.push('9:1');
        return this.withGoogle(`https://pay.tryinnerday.com/gut-reset/checkout/?forcePackageId=${parts.join(',')}`);
      }

      withGoogle(url) {
        try {
          if (typeof window.innerdayCheckoutUrl === 'function') return window.innerdayCheckoutUrl(url) || url;
        } catch (error) {}
        return url;
      }

      paintDealCheckout(cart) {
        const checkout = this.querySelector('.cart-drawer__checkout');
        if (!checkout) return;
        checkout.href = this.dealCheckoutUrl(cart?.items) || this.defaultCheckout || checkout.href;
      }

      paintShipDates() {
        const now = new Date();
        const ship = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
        if (now.getHours() >= 17) ship.setDate(ship.getDate() + 1);
        const label = ship.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' });
        document.querySelectorAll('[data-cart-ship-date]').forEach((node) => {
          node.textContent = label;
        });
      }

      open() {
        this.lastFocus = document.activeElement;
        if (!document.documentElement.classList.contains('cart-open')) {
          const gap = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
          document.documentElement.style.setProperty('--scrollbar-gap', `${gap}px`);
        }
        this.classList.add('is-open');
        document.documentElement.classList.add('cart-open');
        this.panel.focus({ preventScroll: true });
      }

      close() {
        this.classList.remove('is-open');
        window.setTimeout(() => {
          if (this.classList.contains('is-open')) return;
          document.documentElement.classList.remove('cart-open');
          this.lastFocus?.focus({ preventScroll: true });
        }, 280);
      }

      async add(form) {
        const refill = form.querySelector('[data-pdp-refill]');
        const idInput = form.querySelector('[name="id"]');
        const checked = form.querySelector('[data-pdp-deal]:checked');
        if (refill && idInput?.value) {
          let map = {};
          try {
            map = JSON.parse(sessionStorage.getItem('innerday-deals') || '{}');
          } catch (error) {
            map = {};
          }
          const url = (refill.checked ? checked?.dataset.linkRefill : checked?.dataset.linkOnce) || '';
          map[idInput.value] = { mode: refill.checked ? 'refill' : 'once', url };
          sessionStorage.setItem('innerday-deals', JSON.stringify(map));
          sessionStorage.removeItem('innerday-deal-pack');
          sessionStorage.removeItem('innerday-checkout-url');
          if (checked?.dataset.package && checked.dataset.variantId) {
            const deal = this.dealLines();
            deal[checked.dataset.variantId] = checked.dataset.package;
            sessionStorage.setItem('innerday-deal-lines', JSON.stringify(deal));
          } else {
            sessionStorage.removeItem('innerday-deal-lines');
          }
        }
        this.adding = true;
        this.seedGiftShot(form);
        this.seedCompares(form);
        this.setAddingButton(form, true);
        const started = performance.now();
        const estimate = this.lastAddMs || 900;
        let handed = false;
        const handoff = () => {
          if (handed) return;
          handed = true;
          this.buttonMs = performance.now() - started;
          this.pauseAddingButton(form);
          this.showLoading();
          this.open();
        };
        const handoffTimer = window.setTimeout(handoff, Math.max(280, Math.round(estimate / 2)));
        const settle = async () => {
          window.clearTimeout(handoffTimer);
          this.lastAddMs = performance.now() - started;
          const late = !handed;
          handoff();
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          const cartMs = performance.now() - started - this.buttonMs;
          const remain = Math.max(0, this.buttonMs - cartMs);
          const hold = late ? Math.min(900, Math.max(680, this.buttonMs)) : Math.min(900, remain);
          if (hold > 40) await new Promise((resolve) => window.setTimeout(resolve, hold));
        };
        const root = window.Shopify?.routes?.root || '/';
        const dealItems = await this.dealItems(form);
        try {
          const teaId = Number(form.querySelector('[data-gg-tea]')?.value);
          const packItems = teaId && dealItems ? dealItems.filter((line) => line.id !== teaId) : dealItems;
          const teaItems = teaId && dealItems ? dealItems.filter((line) => line.id === teaId) : [];
          const added = packItems
            ? await this.addItems(root, packItems)
            : await fetch(`${root}cart/add.js`, {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body: new FormData(form),
            });
          if (!added || (added.ok === false)) {
            this.adding = false;
            window.clearTimeout(handoffTimer);
            if (handed) await this.refresh();
            return;
          }
          if (teaItems.length) await this.addItems(root, teaItems);
          const payload = await added.json().catch(() => null);
          await settle();
          const addedItems = payload?.items || (payload?.key ? [payload] : []);
          if (addedItems.length && this.cart) {
            const previous = this.cart.items || [];
            const keys = new Set(previous.map((item) => item.key));
            const items = previous.concat(addedItems.filter((item) => item?.key && !keys.has(item.key)));
            this.adding = false;
            this.cart = {
              item_count: items.reduce((sum, item) => sum + (item.quantity || 1), 0),
              items,
              cart_level_discount_applications: this.cart.cart_level_discount_applications || [],
            };
            this.render(this.cart);
          }
          this.refresh();
        } finally {
          window.clearTimeout(handoffTimer);
          this.adding = false;
          this.setAddingButton(form, false);
        }
      }

      pauseAddingButton(form) {
        const root = form.closest('[data-pdp]') || document;
        root.querySelectorAll('.pdp__submit, [data-pdp-bar-add]').forEach((button) => {
          button.classList.remove('is-adding');
          button.removeAttribute('aria-busy');
        });
      }

      setAddingButton(form, on) {
        const root = form.closest('[data-pdp]') || document;
        root.querySelectorAll('.pdp__submit, [data-pdp-bar-add]').forEach((button) => {
          button.classList.toggle('is-adding', on);
          button.setAttribute('aria-busy', on ? 'true' : 'false');
          if (on) {
            button.dataset.wasDisabled = button.disabled ? '1' : '';
            button.disabled = true;
          } else {
            button.disabled = button.dataset.wasDisabled === '1';
          }
        });
      }

      async addItems(root, items) {
        return fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
      }

      async dealItems(form) {
        const checked = form.querySelector('[data-pdp-deal]:checked');
        if (!checked?.dataset.variantId) return null;
        const refill = form.querySelector('[data-pdp-refill]');
        const item = {
          id: Number(checked.dataset.variantId),
          quantity: 1,
        };
        const subscribing = Boolean(refill?.checked && checked.dataset.planId);
        if (subscribing) item.selling_plan = Number(checked.dataset.planId);
        const items = [item];
        const packs = { 2: 1, 3: 2 }[Number(checked.value)] || 0;
        const deals = form.querySelector('[data-pdp-deals]');
        const onceId = Number(deals?.getAttribute('data-bundle-once'));
        const bundleIds = onceId
          ? [onceId]
          : [deals?.getAttribute('data-bundle-tea'), deals?.getAttribute('data-bundle-cup')]
            .map((id) => Number(id))
            .filter((id) => id);
        const giftId = Number(checked.value) === 3 ? deals?.dataset.giftTwo : deals?.dataset.giftOne;
        if (!subscribing && Number(checked.value) === 3 && bundleIds.length && checked.dataset.planId) {
          bundleIds.forEach((id) => {
            if (!items.some((line) => line.id === id)) items.push({ id, quantity: 1 });
          });
        } else if (!subscribing && packs && checked.dataset.planId && giftId) {
          items.push({ id: Number(giftId), quantity: 1 });
        }
        const teaId = Number(form.querySelector('[data-gg-tea]')?.value);
        const supply = Number(checked.value);
        if (teaId && (supply === 2 || supply === 3) && !items.some((line) => line.id === teaId)) {
          items.push({ id: teaId, quantity: 1 });
        }
        return items;
      }

      showLoading() {
        const lines = this.querySelector('[data-cart-lines]');
        if (lines) {
          const mark = '<svg viewBox="0 0 215.11 166.93" aria-hidden="true"><path d="M214.76 103.35 0.65 103.39c2.14-23.22 11.04-45.26 25.56-63.43 10.2-12.77 22.39-22.04 36.95-29.21 34.02-16.73 73.62-13.85 104.77 7.98 27.13 19.59 44.66 49.83 46.83 84.61Z"/><rect x="0" y="119.05" width="215.11" height="47.88"/></svg>';
          lines.innerHTML = `<div class="cart-loading" role="status"><div class="cart-loading__mark">${mark.replace('<svg ', '<svg class="cart-loading__ghost" ')}<span class="cart-loading__fill">${mark}</span></div><p class="cart-loading__note">Adding to your cart…</p></div>`;
        }
        if (this.footer) this.footer.hidden = true;
        const shipbar = this.querySelector('[data-cart-shipbar]');
        if (shipbar) shipbar.hidden = true;
        const extra = this.querySelector('[data-cart-extra]');
        if (extra) extra.hidden = true;
        const organizer = this.querySelector('[data-cart-organizer]');
        if (organizer) organizer.hidden = true;
      }

      isGutLine(item) {
        const handles = ['papaya-seeds-gut-reset-complex', 'innerday-papaya-seeds-gut-reset-complex', 'ova9-papaya-seeds-gut-reset-complex'];
        if (handles.includes(item.handle)) return true;
        const title = (item.product_title || '').toLowerCase();
        if (title.includes('gut reset') && title.includes('papaya')) return true;
        return item.selling_plan_allocation?.selling_plan?.name === 'DEAL!';
      }

      gutPack(cart) {
        const titles = ['1 Pack', '2 Packs', '3 Packs', '15-Day Starter', '30-Day Routine', '45-Day Routine'];
        return (cart?.items || []).some((item) => this.isGutLine(item) && titles.includes(item.variant_title));
      }

      fullPack(cart) {
        return (cart?.items || []).some((item) => this.isGutLine(item) && (item.variant_title === '3 Packs' || item.variant_title === '45-Day Routine'));
      }

      cleanseBundle(cart) {
        const deal = this.dealLines();
        return (cart?.items || []).some((item) => String(deal[item.variant_id]) === '13');
      }

      paintUpsells(cart, visibleQty) {
        const gut = this.gutPack(cart);
        const full = this.fullPack(cart);
        const extra = this.querySelector('[data-cart-extra]');
        const organizer = this.querySelector('[data-cart-organizer]');
        if (extra) {
          const id = Number(extra.dataset.variantId);
          const covered = extra.dataset.extraPackage === '18' && this.cleanseBundle(cart);
          extra.hidden = visibleQty === 0 || full || covered || cart.items.some((item) => item.variant_id === id);
        }
        if (organizer) {
          const id = Number(organizer.dataset.variantId);
          organizer.hidden = visibleQty === 0 || !gut || cart.items.some((item) => item.variant_id === id);
        }
      }

      async addVariant(id, button) {
        if (!id) return;
        const label = button?.textContent;
        if (button) {
          button.disabled = true;
          button.textContent = 'Adding…';
        }
        this.classList.add('is-syncing');
        try {
          const added = await this.addItems(window.Shopify?.routes?.root || '/', [{ id, quantity: 1 }]);
          if (!added || added.ok === false) return;
          const payload = await added.json().catch(() => null);
          const fresh = (payload?.items || []).filter((item) => item?.key);
          if (fresh.length && this.cart) {
            const keys = new Set(fresh.map((item) => item.key));
            const items = this.cart.items.filter((item) => !keys.has(item.key)).concat(fresh);
            this.cart = { ...this.cart, items, item_count: items.reduce((sum, item) => sum + (item.quantity || 0), 0) };
            this.render(this.cart);
          }
          await this.refresh();
        } finally {
          this.classList.remove('is-syncing');
          if (button) {
            button.disabled = false;
            button.textContent = label;
          }
        }
      }

      async toggleGuard(input) {
        const id = Number(input.dataset.variantId);
        if (!id) return;
        input.disabled = true;
        this.classList.add('is-syncing');
        try {
          const root = window.Shopify?.routes?.root || '/';
          if (input.checked) {
            const added = await fetch(`${root}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id, quantity: 1 }),
            });
            if (!added.ok) input.checked = false;
          } else {
            const line = (this.cart?.items || []).find((item) => item.variant_id === id);
            if (line?.key) {
              await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ id: line.key, quantity: 0 }),
              });
            }
          }
          await this.refresh();
        } finally {
          this.classList.remove('is-syncing');
          input.disabled = false;
        }
      }

      seedCompares(form) {
        const handle = window.location.pathname.split('/products/')[1]?.split('/')[0] || '';
        if (!handle) return;
        if (!this.compareCache) this.compareCache = {};
        if (!this.compareCache[handle]) this.compareCache[handle] = {};
        if (!this.variantIds) this.variantIds = {};
        if (!this.variantIds[handle]) this.variantIds[handle] = {};
        form.querySelectorAll('[data-pdp-deal]').forEach((deal) => {
          const id = Number(deal.dataset.variantId);
          const compare = Number(deal.dataset.compare);
          const title = deal.dataset.variantTitle;
          if (id && compare) this.compareCache[handle][id] = compare;
          if (id && title) this.variantIds[handle][title] = id;
        });
        this.rememberCatalog();
      }

      readCatalog() {
        if (!this.compareCache) this.compareCache = {};
        if (!this.variantIds) this.variantIds = {};
        const apply = (entry) => {
          if (!entry?.handle) return;
          this.compareCache[entry.handle] = { ...(this.compareCache[entry.handle] || {}), ...(entry.compares || {}) };
          this.variantIds[entry.handle] = { ...(this.variantIds[entry.handle] || {}), ...(entry.ids || {}) };
        };
        try {
          JSON.parse(sessionStorage.getItem('innerday-catalog') || '[]').forEach(apply);
        } catch (error) {}
        const node = this.querySelector('[data-cart-catalog]');
        if (!node) return;
        try {
          JSON.parse(node.textContent || '[]').forEach(apply);
        } catch (error) {}
        this.rememberCatalog();
      }

      rememberCatalog() {
        const handles = new Set([...Object.keys(this.compareCache || {}), ...Object.keys(this.variantIds || {})]);
        const list = [...handles].map((handle) => ({
          handle,
          compares: this.compareCache?.[handle] || {},
          ids: this.variantIds?.[handle] || {},
        }));
        try {
          sessionStorage.setItem('innerday-catalog', JSON.stringify(list));
        } catch (error) {}
      }

      seedGiftShot(form) {
        const one = form.querySelector('[data-pdp-deal][value="1"]');
        const handle = window.location.pathname.split('/products/')[1]?.split('/')[0] || '';
        const src = one?.dataset.image;
        if (!handle || !src) return;
        if (!this.giftShots) this.giftShots = {};
        this.giftShots[handle] = src;
      }

      async change(key, quantity) {
        if (!key || key === 'pending') return;
        const qty = Math.max(0, quantity);
        this.showChange(key, qty);
        const seq = (this.changeSeq || 0) + 1;
        this.changeSeq = seq;
        this.classList.add('is-syncing');
        const root = window.Shopify?.routes?.root || '/';
        this.changeQueue = (this.changeQueue || Promise.resolve()).then(async () => {
          const response = await fetch(`${root}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: key, quantity: qty }),
          });
          return response.ok ? response.json() : null;
        }).catch(() => null);
        const cart = await this.changeQueue;
        if (seq !== this.changeSeq) return;
        this.classList.remove('is-syncing');
        if (cart?.items) {
          this.cart = cart;
          this.render(cart);
        } else {
          await this.refresh();
        }
      }

      showChange(key, qty) {
        if (!this.cart?.items) return;
        const items = this.cart.items.flatMap((item) => {
          if (item.key !== key) return [item];
          if (!qty) return [];
          const each = (value) => Math.round((value || 0) / (item.quantity || 1));
          return [{
            ...item,
            quantity: qty,
            line_price: each(item.line_price) * qty,
            final_line_price: each(item.final_line_price) * qty,
            original_line_price: each(item.original_line_price) * qty,
          }];
        });
        this.cart = { ...this.cart, items, item_count: items.reduce((sum, item) => sum + (item.quantity || 0), 0) };
        this.render(this.cart);
      }

      async prefetch() {
        const root = window.Shopify?.routes?.root || '/';
        const seq = this.changeSeq || 0;
        try {
          const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
          if (!response.ok) return;
          const cart = await response.json();
          if (seq !== (this.changeSeq || 0)) return;
          this.cart = cart;
          if (this.cart && !this.adding) this.render(this.cart);
        } catch (error) {}
      }

      async refresh() {
        const root = window.Shopify?.routes?.root || '/';
        const seq = this.changeSeq || 0;
        const response = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) return null;
        const cart = await response.json();
        if (seq !== (this.changeSeq || 0)) return this.cart;
        this.cart = cart;
        if (this.adding && !cart.item_count) return cart;
        this.render(cart);
        return cart;
      }

      packs() {
        const base = 'https://shop.tryinnerday.com/1/checkout/?forcePackageId=';
        const one = {
          label: '1 pack',
          gifts: 0,
          refill: { now: 3199, was: 4999, url: `${base}4%3A1`, query: '4%3A1' },
          once: { now: 3999, was: 4999, url: `${base}1%3A1`, query: '1%3A1' },
        };
        const two = {
          label: '2 packs',
          gifts: 1,
          refill: { now: 5599, was: 9998, url: `${base}5%3A1%2C7%3A1`, query: '5%3A1%2C7%3A1' },
          once: { now: 6399, was: 9998, url: `${base}2%3A1%2C7%3A1`, query: '2%3A1%2C7%3A1' },
        };
        const three = {
          label: '3 packs',
          gifts: 2,
          refill: { now: 7198, was: 14997, url: `${base}6%3A1%2C7%3A2`, query: '6%3A1%2C7%3A2' },
          once: { now: 8398, was: 14997, url: `${base}3%3A1%2C7%3A2`, query: '3%3A1%2C7%3A2' },
        };
        const blankLinks = (deal) => ({
          ...deal,
          refill: { ...deal.refill, url: '' },
          once: { ...deal.once, url: '' },
        });
        return {
          '15-Day Starter': one,
          '30-Day Routine': two,
          '45-Day Routine': three,
          '1 Pack': blankLinks(one),
          '2 Packs': blankLinks(two),
          '3 Packs': blankLinks(three),
        };
      }

      modeFor(item) {
        try {
          const map = JSON.parse(sessionStorage.getItem('innerday-deals') || '{}');
          const entry = map[item.variant_id];
          const stored = entry && typeof entry === 'object' ? entry.mode : entry;
          if (stored === 'once') return 'once';
        } catch (error) {}
        return 'refill';
      }

      livePrice(item) {
        return item?.handle === 'papaya-seeds-gut-reset-complex'
          || item?.handle === 'innerday-papaya-seeds-gut-reset-complex'
          || item?.handle === 'ova9-papaya-seeds-gut-reset-complex';
      }

      offerFor(item) {
        if (this.livePrice(item)) return null;
        if (['1 Pack', '2 Packs', '3 Packs', '15-Day Starter', '30-Day Routine', '45-Day Routine'].includes(item.variant_title)) return null;
        const deal = this.packs()[item.variant_title];
        if (!deal) return null;
        const price = deal[this.modeFor(item)];
        const qty = item.quantity || 1;
        return {
          label: deal.label,
          gift: deal.gifts * qty,
          now: price.now * qty,
          was: price.was * qty,
        };
      }

      guardId() {
        return Number(this.querySelector('[data-cart-guard]')?.dataset.variantId || 0);
      }

      visibleItems(cart) {
        const id = this.guardId();
        return (cart?.items || []).filter((item) => item.variant_id !== id);
      }

      displayOf(item) {
        const extra = this.querySelector('[data-cart-extra]');
        const offerPrice = Number(extra?.dataset.price || 0);
        if (extra && offerPrice && Number(extra.dataset.variantId) === Number(item.variant_id)) {
          const qty = item.quantity || 1;
          const now = offerPrice * qty;
          const wasUnit = Number(extra.dataset.compare || 0);
          const was = wasUnit > offerPrice ? wasUnit * qty : now;
          return { now, was, save: Math.max(0, was - now), label: '', gift: false };
        }
        const offer = this.offerFor(item);
        if (offer) {
          const save = Math.max(0, offer.was - offer.now);
          return { now: offer.now, was: offer.was, save, label: offer.label, gift: offer.gift };
        }
        const { base, save } = this.lineSave(item);
        return { now: item.final_line_price, was: base, save, label: '', gift: false };
      }

      lineSave(item) {
        let compareUnit = this.compareCache?.[item.handle]?.[item.variant_id] || 0;
        const extra = this.querySelector('[data-cart-extra]');
        if (!compareUnit && extra && Number(extra.dataset.variantId) === Number(item.variant_id)) {
          compareUnit = Number(extra.dataset.compare || 0);
        }
        const compareLine = compareUnit > item.final_price ? compareUnit * item.quantity : 0;
        const base = Math.max(compareLine, item.original_line_price);
        return { base, save: Math.max(0, base - item.final_line_price) };
      }

      render(cart) {
        const visible = this.visibleItems(cart);
        const visibleQty = visible.reduce((sum, item) => sum + (item.quantity || 0), 0);
        if (!visible.length && cart.items.length && !this.droppingGuard) {
          const hidden = cart.items.find((item) => item.variant_id === this.guardId());
          if (hidden?.key) {
            this.droppingGuard = true;
            this.change(hidden.key, 0).finally(() => {
              this.droppingGuard = false;
            });
            return;
          }
        }

        const count = document.querySelector('[data-cart-count]');
        if (count) {
          count.textContent = visibleQty;
          count.hidden = visibleQty === 0;
        }

        const lines = this.querySelector('[data-cart-lines]');
        const shipbar = this.querySelector('[data-cart-shipbar]');
        this.footer.hidden = visibleQty === 0;
        if (shipbar) shipbar.hidden = visibleQty === 0;

        const goal = 3000;
        const totals = cart.items.reduce((sum, item) => {
          const shown = this.displayOf(item);
          sum.now += shown.now;
          sum.was += shown.save > 0 ? shown.was : shown.now;
          sum.save += shown.save;
          return sum;
        }, { now: 0, was: 0, save: 0 });
        const label = this.querySelector('[data-cart-shipbar-label]');
        if (label) {
          label.textContent = totals.now >= goal
            ? 'Congrats, you have unlocked free shipping!'
            : `Add ${this.formatMoney(goal - totals.now)} for free shipping`;
        }
        const guard = this.querySelector('[data-cart-guard]');
        if (guard) {
          const id = Number(guard.dataset.variantId);
          guard.checked = cart.items.some((item) => item.variant_id === id);
        }
        this.paintUpsells(cart, visibleQty);

        const discount = this.querySelector('[data-cart-discount]');
        const discountAmount = this.querySelector('[data-cart-discount-amount]');
        if (discount) discount.hidden = totals.save <= 0;
        if (discountAmount) discountAmount.textContent = `−${this.formatMoney(totals.save)}`;

        const was = this.querySelector('[data-cart-subtotal-was]');
        if (was) {
          was.hidden = totals.save <= 0;
          was.textContent = this.formatMoney(totals.was);
        }
        if (this.subtotal) this.subtotal.textContent = this.formatMoney(totals.now);
        const checkoutNow = this.querySelector('[data-cart-checkout-now]');
        const checkoutWas = this.querySelector('[data-cart-checkout-was]');
        if (checkoutNow) checkoutNow.textContent = this.formatMoney(totals.now);
        if (checkoutWas) {
          checkoutWas.hidden = totals.save <= 0;
          checkoutWas.textContent = this.formatMoney(totals.was);
        }
        this.paintDealCheckout(cart);

        if (!lines) return;
        if (!visible.length) {
          if (this.adding) {
            this.showLoading();
            return;
          }
          const mark = this.dataset.emptyMark
            ? `<img src="${this.escape(this.dataset.emptyMark)}" alt="" width="56" height="44">`
            : '';
          lines.innerHTML = `<div class="cart-empty"><span class="cart-empty__mark" aria-hidden="true">${mark}</span><p class="cart-empty__title">${this.escape(this.labels.empty)}</p><button class="button cart-empty__shop" type="button" data-cart-close><span class="button__label">Continue shopping</span></button></div>`;
          return;
        }

        lines.innerHTML = `<ul class="cart-drawer__lines">${visible.map((item) => this.line(item)).join('')}</ul>`;
        this.paintShipDates();
      }

      isGift(item) {
        if ((item.final_line_price || 0) > 0) return false;
        if ((item.original_line_price || 0) > 0) return true;
        const discounts = [...(item.discounts || []), ...(item.line_level_discount_allocations || [])];
        if (discounts.some((entry) => /gift/i.test(entry.title || entry.discount_application?.title || ''))) return true;
        return Object.keys(item.properties || {}).some((key) => /gift/i.test(key));
      }

      line(item) {
        const image = item.image
          ? `<a class="cart-drawer__media" href="${this.escape(item.url)}"><img src="${this.escape(item.image)}" alt="" width="160" height="160"></a>`
          : '<span class="cart-drawer__media"></span>';
        const shown = this.displayOf(item);
        const trash = (key) => `<button class="cart-drawer__remove" type="button" data-cart-remove data-line-key="${this.escape(key)}" aria-label="${this.escape(this.labels.remove)}"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4.5 7h15" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/><path d="M9.2 7V5.6c0-.9.7-1.6 1.6-1.6h2.4c.9 0 1.6.7 1.6 1.6V7" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/><path d="M7 7.2 8 19.1a1.4 1.4 0 0 0 1.4 1.3h5.2a1.4 1.4 0 0 0 1.4-1.3L17 7.2" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></svg></button>`;
        const giftPrices = (was) => {
          const struck = was > 0 ? `<s>${this.formatMoney(was)}</s>` : '';
          const saved = was > 0 ? `<p class="cart-drawer__saveflag">You save ${this.formatMoney(was)}</p>` : '';
          return `<div class="cart-drawer__prices"><span class="cart-drawer__now">${struck}<span class="cart-drawer__free">FREE</span></span>${saved}</div>`;
        };
        if (this.isGift(item)) {
          const pack = ['1 Pack', '15-Day Starter'].includes(item.variant_title)
            ? '<span>1 pack</span>'
            : '';
          const giftWas = shown.was || item.original_line_price || 0;
          return `<li class="cart-drawer__line cart-drawer__line--gift">
            ${image}
            <div class="cart-drawer__info">
              <div class="cart-drawer__top">
                <a class="cart-drawer__name" href="${this.escape(item.url)}">${this.escape(item.product_title)}</a>
                ${trash(item.key)}
              </div>
              <div class="cart-drawer__split">
                <div class="cart-drawer__meta"><p class="cart-drawer__giftrow">${pack}<span class="cart-drawer__giftbadge">Free gift</span></p></div>
                ${giftPrices(giftWas)}
              </div>
            </div>
          </li>`;
        }
        const planName = item.selling_plan_allocation?.selling_plan?.name || '';
        const variantLabel = shown.label || [item.variant_title, shown.label ? '' : planName].filter(Boolean).join(' · ');
        const variant = variantLabel
          ? `<p class="cart-drawer__variant">${this.escape(variantLabel)}</p>`
          : '';
        const flag = shown.save > 0
          ? `<p class="cart-drawer__saveflag">You save ${this.formatMoney(shown.save)}</p>`
          : '';
        const now = shown.save > 0
          ? `<span class="cart-drawer__now"><s>${this.formatMoney(shown.was)}</s><span>${this.formatMoney(shown.now)}</span></span>`
          : `<span>${this.formatMoney(shown.now)}</span>`;
        const giftSrc = this.giftShots?.[item.handle] || item.image;
        const giftImage = giftSrc
          ? `<span class="cart-drawer__media"><img src="${this.escape(giftSrc)}" alt="" width="120" height="120"></span>`
          : '<span class="cart-drawer__media"></span>';
        const starterWas = this.packs()['1 Pack']?.once?.was || 0;
        const giftLine = `<li class="cart-drawer__line cart-drawer__line--gift">
              ${giftImage}
              <div class="cart-drawer__info">
                <p class="cart-drawer__name">${this.escape(item.product_title)}</p>
                <div class="cart-drawer__split">
                  <div class="cart-drawer__meta"><p class="cart-drawer__giftrow"><span>1 pack</span><span class="cart-drawer__giftbadge">Free gift</span></p></div>
                  ${giftPrices(starterWas)}
                </div>
              </div>
            </li>`;
        const gift = giftLine.repeat(Number(shown.gift) || 0);

        return `<li class="cart-drawer__line">
          ${image}
          <div class="cart-drawer__info">
            <div class="cart-drawer__top">
              <a class="cart-drawer__name" href="${this.escape(item.url)}">${this.escape(item.product_title)}</a>
              ${trash(item.key)}
            </div>
            <div class="cart-drawer__split">
              <div class="cart-drawer__meta">
                ${variant}
                <div class="cart-drawer__qty" data-line-key="${this.escape(item.key)}">
                  <button type="button" data-cart-qty="${item.quantity - 1}" aria-label="${this.escape(this.labels.decrease)}">−</button>
                  <span>${item.quantity}</span>
                  <button type="button" data-cart-qty="${item.quantity + 1}" aria-label="${this.escape(this.labels.increase)}">+</button>
                </div>
              </div>
              <div class="cart-drawer__prices">${now}${flag}</div>
            </div>
          </div>
        </li>${gift}`;
      }

      formatMoney(cents) {
        const amount = (cents / 100).toFixed(2);
        return this.moneyFormat
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(Math.round(cents / 100)))
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(cents / 100)))
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
          .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, amount.replace('.', "'"))
          .replace(/\{\{\s*amount\s*\}\}/g, amount);
      }

      escape(value) {
        return String(value ?? '').replace(/[&<>"']/g, (char) => ({
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;',
        })[char]);
      }
    }

    customElements.define('cart-drawer', CartDrawer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nextcommerce-checkout"] && !Shopify.designMode) return;
  try {
    const configNode = document.querySelector('[data-nextcommerce-config]');

  if (configNode) {
    const config = JSON.parse(configNode.textContent);
    const packages = parseMap(config.map || '');

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-nextcommerce-checkout]');
      if (!trigger || !config.url) return;
      event.preventDefault();
      go(trigger);
    });

    async function go(trigger) {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) {
        shopifyCheckout(trigger);
        return;
      }

      const cart = await response.json();
      const lines = new Map();

      for (const item of cart.items) {
        const packageId = packages.variants[String(item.variant_id)] || packages.handles[(item.handle || '').toLowerCase()];
        if (!packageId) {
          shopifyCheckout(trigger);
          return;
        }
        lines.set(packageId, (lines.get(packageId) || 0) + item.quantity);
      }

      if (!lines.size) {
        shopifyCheckout(trigger);
        return;
      }

      try {
        const destination = new URL(config.url, window.location.origin);
        const packed = [...lines.entries()].map(([id, quantity]) => `${id}:${quantity}`).join(',');
        destination.searchParams.set('forcePackageId', packed);
        let tracked = destination.toString();
        try {
          if (typeof window.innerdayCheckoutUrl === 'function') {
            tracked = window.innerdayCheckoutUrl(tracked) || tracked;
          }
        } catch (error) {}
        window.location.assign(tracked);
      } catch {
        shopifyCheckout(trigger);
      }
    }

    function shopifyCheckout(trigger) {
      window.location.assign(trigger.getAttribute('href') || config.shopifyCheckout);
    }

    function parseMap(raw) {
      const variants = {};
      const handles = {};

      raw.split('\n').forEach((line) => {
        const trimmed = line.trim();
        if (!trimmed || trimmed.startsWith('#')) return;

        const variant = trimmed.match(/^variant:\s*(\d+)\s*:\s*(\d+)\s*$/i);
        if (variant) {
          variants[variant[1]] = variant[2];
          return;
        }

        const pair = trimmed.match(/^([^:#]+):\s*(\d+)\s*$/);
        if (pair) handles[pair[1].trim().toLowerCase()] = pair[2];
      });

      return { variants, handles };
    }
  }
  } catch(e) { console.error(e); }
})();

})();
